<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col sm="12">
          <b-button variant="link" @click="go_list()" class="float-right px-0">Quick Guide Exit</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- progress bar -->
        <b-col sm="1"></b-col>
        <b-col sm="10">
          <p>
            <StepProgress active-color="black" :steps="steps['EN']" :current-step="status.step" />
          </p>
        </b-col>
        <b-col sm="1"></b-col>
      </b-row>
      <hr>
      <b-row class="step_box mb-4" v-if="status.step != 1">
        <b-col>
          {{steps['EN'][status.step]}}
        </b-col>
      </b-row>
      <b-row class="step_box mb-4" v-else>
        <b-col>
          {{steps['EN'][status.step]}}
          <p>
          <h4>Create New Policy for Scanning</h4>
          <small>
            This step Automatically generates "Quick scanning" policy,
            later you can configure a new policy or this policy edit, remove can do it
          </small>
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <transition-group name="slide-fade">
            <!-- first -->
            <b-form-group v-if="status.step == 0" v-bind:key="0">
              <b-input-group class="text-center">
                <b-input-group-prepend>
                  <b-input-group-append is-text>
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox" checked="">
                      <div class="checkbox-animate">
                        <small style="margin-top:2px;" class="checkbox-off">HTTP</small>
                        <small style="margin-top:2px;" class="checkbox-on">HTTPS</small>
                      </div>
                    </div>
                  </b-input-group-append>
                  <b-input-group-text>
                    FQDN
                    <a class="ml-2" href="javascript:void(0);" v-b-tooltip.hover.hover
                      title="www.f1security.co.kr, img.f1security.co.kr, ftp.f1security.co.kr => FQDN is f1security.co.kr">
                      <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                    </a>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn"
                  placeholder="FQDN (ex : company.com)" v-model="model.fqdn" @keypress.enter="next()"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!-- seconed -->
            <b-form-group v-if="status.step == 1" v-bind:key="1">
              <b-row>
                <b-col>
                  <strong class="d-inline-block float-left">Policy : {{policy_description}}</strong>
                  <b-button class="d-inline-block float-right" v-if="policy_has" variant="link"
                    @click="modal_policy= true">Using existing policy</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  Enter whether to check by moving (path) the link from the first page to the next. The default value for Quick Setup is ${policy.depth}
                  `">
                  <span class="col-form-label">
                    Maximum path depth
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10"
                    :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  Enter the maximum sublink to navigate within a page.
                  Ignore any excess links.
                  Normally if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way.
                  The default value for Quick Setup is ${policy.links}`">
                  <span class="col-form-label">
                    Sub Page Link
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                Total number of pages to check on the inspection site.
                End the check when the entered number is reached.
                can be specified within the range of 1 to license limit.
                The default value for Quick Setup is ${policy.limit}`">
                  <span class="col-form-label">
                    Maximum Navigation Page
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1"
                    :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                </b-col>
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                  Time to wait for page loading.
                  can be specified within the range of 1-30.
                  The default value for Quick Setup is ${policy.timeout}`">
                  <span class="col-form-label">
                    TimeOut(Second)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1"
                    :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col md="2" v-b-tooltip.hover.hover :title="`
                Time to wait before moving to a new page.
                can be specified within the range of 1 to 10 000.
                The default value for Quick Setup is ${policy.delay}`">
                  <span class="col-form-label">
                    Check Speed(Millisecond)
                  </span>
                  <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
                </b-col>
                <b-col md="4">
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0"
                    :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
            <!-- final -->
            <b-form-group v-if="status.step == 2" v-bind:key="2">
              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * Charging will begin when the first site registration is made and scanning started.
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree1"
                    @change="(x) => model.is_start = x && status.agree2 && status.agree3 && status.agree4 ">
                    I've checked, and I agree.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    * Traffic is generated on the actual website
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree2"
                    @change="(x) => model.is_start = status.agree1 && x && status.agree3 && status.agree4 ">
                    I've checked, and I agree.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <span class="text-danger font-weight-light">
                    Please refer to the terms and conditions for details.
                  </span>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree3"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && x && status.agree4 ">
                    I've checked, and I agree.
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="1"></b-col>
                <b-col>
                  <strong class="text-danger">Scheduling Everyday at AM {{status.interval}}</strong>
                </b-col>
                <b-col>
                  <b-form-checkbox class="mr-n2 mb-n1" v-model="status.agree4"
                    @change="(x) => model.is_start = status.agree1 && status.agree2 && status.agree3 && x ">
                    I've checked, and I agree.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <hr>
              <b-row class="text-center">
                <b-col md="12">
                  <b-form-checkbox class="mr-n2 mb-n1"
                    @change="(x) => { status.agree1 = x; status.agree2 = x; status.agree3 = x; status.agree4 = x }"
                    v-model="model.is_start" ref="agreement">
                    <strong>I've All checked, and I agree.</strong>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- final -->
            <b-form-group v-if="status.step == 3" v-bind:key="2">
              <center>
                <p>Complated Quick configure</p>
                <p>The inspection will begin shortly.</p>
                <p></p>
                <b-button variant="link" @click="go_site()" class="px-0">You can reset the site in detail </b-button>
                or
                <b-button variant="link" @click="go_policy()" class="px-0">modify the inspection policy </b-button>
              </center>
            </b-form-group>
          </transition-group>
        </b-col>
      </b-row>
      <hr>
      <!-- 마지막에는 이전이 없어야 함 -->
      <b-row>
        <b-col>
          <b-button v-if="status.step > 0 && status.step < steps['EN'].length - 1" block size="sm" variant="info"
            @click="prev()"> Prev </b-button>
          <!-- <b-button v-else  block size="sm" variant="success" @click="go_list">Complete</b-button> -->
        </b-col>
        <b-col>
          <b-button v-if="status.step < steps['EN'].length - 1" block size="sm" variant="primary" @click="next()">Next
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <link rel="stylesheet" href="custom/wmds.site.quick.setup.css">
    <!-- delete modal -->
    <b-modal size="xl" title="Choice Policy" class="modal-primary" v-model="modal_policy" @ok="modal_policy = false"
      header-bg-variant="primary" ok-variant="primary">
      <PolicyList :use_view="false"
        @selected="x => { policy = Object.assign({}, policy, x.policy); policy_description = x.description; modal_policy = false; policy_selected = true; status.policy_id = x.id }" />
    </b-modal>
  </div>
</template>
<style>
  .step-progress__step-label {
    font-size: 1.3em !important;
  }

  @media (max-width: 1200px) {
    .step-progress__step-label {
      font-size: 0.9em !important;
    }
  }

  @media (max-width: 767px) {
    .step-progress__step-label {
      font-size: 0.6em !important;
    }
  }
</style>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
